<template>
  <div>
    <div class="box has-background-white-bis" style="padding: 10px;">
      <b-field grouped style="margin-bottom: 0;">
        <b-field label="Mulai pada" expanded>
          <datetime-picker :datetime="started_at" :onChange="(datetime) => started_at = datetime"></datetime-picker>
        </b-field>

        <b-field label="Selesai pada" expanded>
          <button class="button is-fullwidth" v-if="isEmpty(end_at)" @click.prevent="setEndAt">
            <span class="icon"><b-icon icon="plus"></b-icon></span>
            <span>Tambah waktu selesai</span>
          </button>
          
          <div class="columns is-mobile is-gapless" v-else>
            <div class="column">
              <datetime-picker :datetime="end_at" :min_datetime="started_at" :onChange="(datetime) => end_at = datetime"></datetime-picker>
            </div>

            <div class="column is-narrow" style="margin-left: 5px;">
              <button class="button has-text-danger" @click.prevent="setEndAt">
                <span class="icon"><b-icon icon="close"></b-icon></span>
              </button>
            </div>
          </div>
        </b-field>
      </b-field>

      <b-field label="Lokasi" expanded>
        <b-input v-model="location" placeholder="Lokasi"></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
import DatetimePicker from '~/components/DateTimePicker';

export default {
  components: {
    DatetimePicker
  },
  
  props: {
    onChangeEvent: {
      type: Function,
      default: () => {}
    },
    started_data: {
      type: [String, Number],
      default: null
    },
    end_at_data: {
      type: [String, Number],
      default: null
    },
    location_data: {
      type: String,
      default: null
    }
  },

  watch: {
    started_at() {
      this.onChangeEvent(this.getEventResponse())
    },
    end_at() {
      this.onChangeEvent(this.getEventResponse())
    },
    location() {
      this.onChangeEvent(this.getEventResponse())
    },
  },

  data() {
    return {
      started_at: !this.isEmpty(this.started_data) ?  moment(this.started_data).format('YYYY-MM-DD HH:mm:ss') : moment().format('YYYY-MM-DD HH:mm:ss'),
      end_at: !this.isEmpty(this.end_at_data) ?  moment(this.end_at_data).format('YYYY-MM-DD HH:mm:ss') : null,
      location: !this.isEmpty(this.location_data) ? _.clone(this.location_data) : null
    }
  },

  methods: {
    setEndAt() {
      if (!this.isEmpty(this.end_at)) {
        this.end_at = null;
      } else {
        this.end_at = moment().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
      }
    },
    getEventResponse() {
      return {
        started: this.started_at,
        end_at: this.end_at,
        location: this.location
      }
    }
  },
}
</script>